<template>
    <button :class="{'btn--spin-visible': isSaving}" class="mdc-button mdc-button--raised btn--spinner" @click="addSpinAndRedirect">{{ text }}</button>
</template>

<script>
    export default {
        props: {
            customMethod: {
                type: Function
            },
            text: {
                type: String,
                default: 'Button'
            },
				isSaving: Boolean
        },
        data: function() {
            return {
            }
        },
        methods: {
            addSpinAndRedirect: function() {
                this.customMethod();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ButtonWithSpinner.vue